import { showNotification } from '../../NotificationBanner/showNotification';

export const showPromptErrorNotification = () => {
  showNotification({
    type: 'error',
    title: '',
    message: 'There was a problem with saving your prompt.',
  });
};
